import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { Box, Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { PredicateChips } from '~/pages/DraftsDashboard/DraftsAiSearch/DraftsAiSearchChips/PredicateChips/PredicateChips';
import styles from './OrGroup.module.scss';
import { armChipTestIds, armReactKeys, collapsibleStringGroup } from './OrGroup.utils';
import { OrStringGroupChip } from './OrStringGroupChip/OrStringGroupChip';
export const GetOrGroupTID = (parentTestId)=>getTestIds(parentTestId);
export const OrGroup = (param)=>{
    let { testId, arms, tone, onArmChange, onToggleConnector, onClearGroup } = param;
    const { OrGroupTestIds } = useMemo(()=>GetOrGroupTID(testId), [
        testId
    ]);
    if (arms.length === 0) return null;
    const collapsed = collapsibleStringGroup(arms);
    if (collapsed != null) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: OrGroupTestIds.Root(),
            inline: true,
            className: styles.noWrapCluster,
            children: /*#__PURE__*/ _jsx(OrStringGroupChip, {
                testId: OrGroupTestIds.StringGroup(),
                field: collapsed.field,
                predicates: collapsed.predicates,
                tone: tone,
                onValueChange: (index, predicate)=>onArmChange(index, predicate == null ? undefined : {
                        [collapsed.field]: predicate
                    }),
                onToggleConnector: ()=>onToggleConnector === null || onToggleConnector === void 0 ? void 0 : onToggleConnector(),
                onRemove: onClearGroup
            })
        });
    }
    const reactKeys = armReactKeys(arms);
    return /*#__PURE__*/ _jsx(Box, {
        testId: OrGroupTestIds.Root(),
        inline: true,
        className: styles.noWrapCluster,
        children: /*#__PURE__*/ _jsx(Row, {
            alignItems: "center",
            gap: 8,
            wrap: true,
            children: arms.map((arm, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                            testId: OrGroupTestIds.Connector(index),
                            tone: tone,
                            onToggle: onToggleConnector
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            testId: OrGroupTestIds.Arm(index),
                            inline: true,
                            children: /*#__PURE__*/ _jsx(Row, {
                                alignItems: "center",
                                gap: 4,
                                children: /*#__PURE__*/ _jsx(PredicateChips, {
                                    predicate: arm,
                                    onChange: (next)=>onArmChange(index, next),
                                    testIds: armChipTestIds(OrGroupTestIds.Arm(index))
                                })
                            })
                        })
                    ]
                }, reactKeys[index]))
        })
    });
};
